import React from "react";
import { useGetMe } from "@workspace/api-client-react";
import { AgentDashboard } from "./agent/AgentDashboard";
import { MasterDealerDashboard } from "./master-dealer/MasterDealerDashboard";
import { AccountManagerDashboard } from "./account-manager/AccountManagerDashboard";
import { AdminDashboard, OperationsDashboard } from "./admin/AdminDashboard";
import { FinanceDashboard } from "./finance/FinanceDashboard";
import { SupportDashboard } from "./support/SupportDashboard";

export function HomeRouter() {
  const { data: me, isLoading } = useGetMe();

  if (isLoading) {
    return (
      <div className="p-8 flex justify-center">
        <div className="animate-pulse bg-gray-200 h-8 w-32 rounded"></div>
      </div>
    );
  }

  if (!me) {
    return <div className="p-8 text-red-500">Failed to load user profile.</div>;
  }

  switch (me.role) {
    case "agent":
      return <AgentDashboard />;
    case "master_dealer":
      return <MasterDealerDashboard />;
    case "account_manager":
      return <AccountManagerDashboard />;
    case "admin":
      return <AdminDashboard />;
    case "finance":
      return <FinanceDashboard />;
    case "poc_support":
      return <SupportDashboard />;
    case "operations":
      return <OperationsDashboard />;
    default:
      return <div className="p-8">Unknown Role Dashboard</div>;
  }
}
